import { useCurrentUserInfo } from '@findy-code/yuffie/graphql';
import { getIsTargetUser } from '@findy-code/yuffie/utils/get-is-target-user';
import { getIsUsSupportUser } from '@findy-code/yuffie/utils/get-is-us-support-user';

export function useHeaderCurrentUserFacade() {
  // MEMO:
  // MainContentContainerでCareerMotivationButtonWithModalContainerを呼び出している。
  // 上記転職意欲コンポーネントで呼び出している、CareerMotivationModalContainerは必ず描画されるようになっている(モーダルUI自体の描画はisOpenで制御されている)。
  // 上記のモーダルContainerでuseCurrentUserInfo内のuseFetchCurrentUserInfoQueryをcache-and-networkで呼び出している。
  // そのためクライアントルーティングが走るたびにuseFetchCurrentUserInfoQuery()が実行されている。
  // そのリクエスト結果のキャッシュを当hookで取得している。
  //
  // プロフィールページなどでユーザーの登録情報を更新しているmutation処理の結果をキャッシュするように修正すれば、
  // CareerMotivationModalContainer自体をisOpenで描画制御しても問題なくなるので、ルーティング時のリクエストが走らなくなる。
  const { currentUser, isCurrentUserLoading } = useCurrentUserInfo({
    fetchPolicy: 'cache-first',
  });

  // TODO: FeatureFlagの削除時に、isUsSupportUserにリネームする
  const isTargetUser =
    process.env.NEXT_PUBLIC_FEATURE_TU_API_REPLACEMENT === 'true'
      ? getIsUsSupportUser({
          isTu: currentUser?.isTu,
          talentStatus: currentUser?.talentStatus,
        })
      : getIsTargetUser({
          age: currentUser?.profile?.age,
          numericAnnualIncome: currentUser?.profile?.numericAnnualIncome,
          prefectureId: currentUser?.profile?.prefecture.id,
          talentStatus: currentUser?.talentStatus,
          jobTypeIds: currentUser?.jobs.map((job) => job.jobTypeId),
          managementJobTypeIds: currentUser?.managementJobs.map(
            (job) => job.managementJobTypeId
          ),
          userJobYearTypeIds: currentUser?.jobs.map(
            (job) => job.userJobYearTypeId
          ),
          userManagementJobYearTypeIds: currentUser?.managementJobs.map(
            (job) => job.userJobYearTypeId
          ),
        });

  const companyName = currentUser?.profile?.companyName ?? '';
  const freelanceWords =
    /(フリーランス|個人事業主|自営業|freelance|self[-\s]employed)/g;
  const isFreelanceUser = companyName
    ? freelanceWords.test(companyName.toLowerCase())
    : false;

  return {
    loading: isCurrentUserLoading,
    isTargetUser,
    isFreelanceUser,
    hasInputRequiredProfile:
      currentUser?.setting?.hasInputRequiredProfile ?? false,
    inputProgress: currentUser?.profile?.inputProgress ?? 0,
    unreadCount: currentUser?.unreadCount ?? 0,
    unreadMessageCount: currentUser?.unreadAllMessageContextCount ?? 0,
    unreadNotificationsJobDescriptionLikeCount:
      currentUser?.unreadNotificationsJobDescriptionLikeCount ?? 0,
    userName: currentUser?.profile?.name ?? '',
    userCareerMotivation: currentUser?.profile?.careerMotivation,
  } as const;
}
